import { Timeline } from 'models'

export const timeline: Timeline = [
  {
    image:
      'https://gdb.rferl.org/cb43e1dd-235f-44e3-87b5-f4082e18918f_w1200.jpg',
    ps: {
      date: 'وږی ۲۱, ۱۴۰۰م کال',
      description: 'د نجونو او هلکانو پر ګډ درس بندیز',
      links: [
        {
          label: 'نور معلومات',
          url: 'https://pa.azadiradio.com/a/31456428.html',
        },
      ],
    },
    prs: {
      date: '۲۱سنبله ۱۴۰۰خورشیدی ',
      description: '  منع آموزش مختلط دختران و پسران.',


      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31456389.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 2
  {
    image:
      'https://gdb.rferl.org/f8da5c46-0bea-49ed-95c6-7dea4f41ecda_w1200.jpg',
    ps: {
      date: 'وږی ۲۶, ۱۴۰۰م کال  ',
      description: 'طالبانو د ښځو چارو وزارت له منځه یووړ  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31466211.html',
        },
      ],
    },
    prs: {
      date: ' ۲۷ سنبله ۱۴۰۰ خورشیدی ',
      description:
        ' طالبان وزارت امور زنان را از بین بردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31466716.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 3
  {
    image: '',
    ps: {
      date: 'وږی ۲۷, ۱۴۰۰م کال ',
      description: 'طالبانو د نجونو پر منځنیو ښوونځيو بندیز ولګاوه  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31466476.html',
        },
      ],
    },
    prs: {
      date: '۲۷ سنبله ۱۴۰۰ خورشیدی ',
      description:
        'طالبان، دختران بالاتر از صنف ششم را از رفتن به مکاتب منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31466691.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 4
  {
    image:
      'https://gdb.rferl.org/94a9c7ee-92b7-4f0b-ad85-ec7f7b29353e_w1200.jpg',
    ps: {
      date: 'لیندۍ ۰۲، ۱۴۰۱م کال ',
      description:
        ' طالبانو د مدافع وکیلانو خپلواکه ټولنه له منځه یووړه او ښځينه قاضیانې او څارنوالانې يې له دندو ګوښه کړې  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32653635.html',
        },
      ],
    },
    prs: {
      date: '۲ قوس ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان انجمن مستقل وکلای مدافع را ازبین بردند، قاضی ها و سارنوالان زن را از وظیفه برطرف  کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32667549.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 5
  {
    image:
      'https://gdb.rferl.org/27d7e7be-21dc-400e-8ed0-0435a9924c27_w1200.jpg',
    ps: {
      date: 'مرغومی ۰۵, ۱۴۰۰م کال ',
      description:
        'طالبانو موټر چلوونکو ته ویلي چې پرته له محرمه دې ښځې نه پورته کوي',
      links: [
        {
          label: 'معلومات',
          url: 'https://da.azadiradio.com/a/31626788.html',
        },
      ],
    },
    prs: {
      date: '۵ جدی ۱۴۰۰ خورشیدی ',
      description:
        'طالبان به راننده های موترهای شهری دستور دادند که زنان بدون محرم را انتقال ندهند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31626788.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 6
  {
    image: '',
    ps: {
      date: 'مرغومی ۱۰، ۱۴۰۰م کال ',
      description:
        ' طالبانو له هټۍ والو او کالي پلورونکو غوښتي چې له هغو نانځکو سرونه پرې کړي چې لباسونه یې پر ځړولي  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31639201.html',
        },
      ],
    },
    prs: {
      date: '  ۲ حوت ۱۴۰۰ خورشیدی ',
      description:
        'طالبان از وزارتخانه ها و ادارات دولتی خواستند که زنان به گفته آنها بدون حجاب را از رفتن به ادارات دولتی منع کنند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31838935.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 7
  {
    image: '',
    ps: {
      date: 'کب ۰۲، ۱۴۰۰م کال ',
      description:
        ' طالبانو له وزارتونو او دولتي ادارو غوښتي چې دوی په خبره بې حجابه ښځې دولتي ادارو ته له تللو منع کړي  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31714539.html',
        },
      ],
    },
    prs: {
      date: '۱۰ جدی ۱۴۰۰ خورشیدی ',
      description:
        'طالبان از دوکانداران و لباس فروشان خواستند که سر مانکن های زن را که نمونه های لباس را پوشانده اند، جدا کنند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32242068.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 8
  {
    image:
      'https://gdb.rferl.org/3aeac277-14ce-4a75-88a4-bbd2f54b3a10_w1200.jpg',
    ps: {
      date: 'کب ۲۴, ۱۴۰۰م کال  ',
      description:
        'طالبانو هغه ښځینه ښوونکې چې هلکانو ته یې درس وایه، اضافه بست کړې  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31754384.html',
        },
      ],
    },
    prs: {
      date: '۲۴ حوت ۱۴۰۰ خورشیدی ',
      description:
        'طالبان آنعده از معلمان زن را که به پسران تدریس می کردند، از وظایف شان اخراج کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31754309.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 9
  {
    image:
      'https://gdb.rferl.org/45da1892-3e5f-4bfa-8655-f609f21c5e00_w1200.jpg',
    ps: {
      date: 'وری ۱۷، ۱۴۰۱م کال  ',
      description:
        'طالبانو په پوهنتونونو کې د نارینه او ښځو ګډو علمي سمینارونو، فراغت غونډو او کنفرانسونو باندې بندیز ولګاوه',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31788966.html',
        },
      ],
    },
    prs: {
      date: '۱۷ حمل ۱۴۰۱ خورشیدی  ',
      description:
        'طالبان سمینار های علمی مختلط برای دانش آموزن دختر و پسر و همچنان جشن های فراغت مختلط آنها را در پوهنتون ها منع اعلام کرد.',
      links: [
        {
          label: ' معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32178235.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 10
  {
    image:
      'https://gdb.rferl.org/82cc89c3-3644-4c09-91e1-e4634da57bbc_w1200.jpg',
    ps: {
      date: 'چنګاښ ۲۸, ۱۴۰۱م کال  ',
      description:
        ' طالبانو په ماليې وزارت کې ښځو ته ویلي چې د ځان پر ځای یو نارینه ورته معرفي کړي.  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31948627.html',
        },
      ],
    },
    prs: {
      date: '۲۸ سرطان ۱۴۰۱خورشیدی ',
      description:
        'طالبان به زنان در وزارت مالیه گفتند که به عوض خود مردی را برای کار معرفی کنند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31950922.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 11
  {
    image:
      'https://gdb.rferl.org/084a0000-0a00-0242-2978-08d9f92aef5a_w1200.jpg',
    ps: {
      date: 'وږی ۲۹, ۱۴۰۱م کال ',
      description: ' طالبانو ښځينه محصلانې له عکس او ويډيو اخيستلو منع کړې  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32042915.html',
        },
      ],
    },
    prs: {
      date: '۲۹ سنبله ۱۴۰۱ خورشیدی ',
      description:
        'طالبان دانش آموزان دختر را از گرفتن عکس و فلم منع کردند.',
      links: [
        {
          label: 'معلوت بیشتر',
          url: 'https://da.azadiradio.com/a/32044806.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 12
  {
    image:
      'https://gdb.rferl.org/e4e9c7b8-31f0-45b3-856c-e10f220dfa39_w1200.jpg',
    ps: {
      date: 'وږی ۳۱، ۱۴۰۱م کال  ',
      description:
        'په کندهار کې طالبان تر شپږم ټولګیو کښته نجونې په دې پلمه ایستلي چې عمرونه یې تر۱۳ کلونو لوړ دي  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32045670.html',
        },
      ],
    },
    prs: {
      date: '۳۱ سنبله ۱۴۰۱خورشیدی ',
      description:
        ' طالبان در قندهار دختران زیر صنف ششم را بخاطری از رفتن به مکتب منع کردند که بالاتر از سیزده سال داشتند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://pa.azadiradio.com/a/32045670.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 13
  {
    image:
      'https://gdb.rferl.org/aecead19-3550-45a0-842d-8d5009cb954a_w1200.jpg',
    ps: {
      date: 'غویی ۰۴، ۱۴۰۱م کال  ',
      description:
        'طالبانو په کابل پوهنتون کې د نجونو او هلکانو د تدریسې ورځو د جلا کولو پرېکړه اعلان کړه  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31818673.html',
        },
      ],
    },
    prs: {
      date: '۴ ثور ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان تصمیم به جداسازی روزهای تدریس دختران و پسران را در پوهنتون کابل اعلام کردند.  ',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31858314.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 14
  {
    ps: {
      date: 'غویی ۱۷, ۱۴۰۱م کال  ',
      description: 'طالبانو د ښځو لپاره حجاب جبري اعلان کړ  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31838788.html',
        },
      ],
    },
    prs: {
      date: '۱۷ ثور ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان حجاب اجباری را بر زنان اعلام کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31852576.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 15
  {
    image: '',
    ps: {
      date: 'غویی ۲۳, ۱۴۰۱م کال',
      description:
        'طالبانو اعلان وکړ چې ښځې له نارینه خپلوانو او کورنیو سره یو ځای په رستورانونو کې ډوډۍ نشي خوړلای',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31847394.html',
        },
      ],
    },
    prs: {
      date: '۲۳ ثور ۱۴۰۱خورشیدی ',
      description:
        'طالبان اعلام کردند که زنان و مردان یکجا در رستورانت ها غذا صرف کنند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31847389.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 16
  {
    image:
      'https://gdb.rferl.org/958ffe57-d5fd-4e56-930e-ce0b24a0659c_w1200.jpg',
    ps: {
      date: 'غویی ۲۶، ۱۴۰۱م کال ',
      description: ' طالبانو د افغانستان د بشري حقونو خپلواک کمیسیون منحل کړ  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31859238.html',
        },
      ],
    },
    prs: {
      date: '۲۶ ثور ۱۴۰۱ خورشیدی ',
      description:
        'طالبان کمیسیون مستقل حقوق بشر افغانستان را منحل کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31854382.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 17
  {
    image:
      'https://gdb.rferl.org/a274fe84-20bf-48f3-98ab-5ad3a9439003_w1200.jpg',
    ps: {
      date: 'غویی ۲۸, ۱۴۰۱',
      description: 'طالبانو پوهنتون ته له رنګه پوړني سره د نجونو مخه ونیوله',
      links: [
        {
          label: 'معلومات',
          url: 'https://da.azadiradio.com/a/31858314.html',
        },
      ],
    },
    prs: {
      date: '۲۸ ثور ۱۴۰۱ خورشیدی ',
      description:
        'طالبان از ورود دختران با لباس های رنگه به پوهنتون کابل جلوگیری کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31858314.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 18
  {
    image:
      'https://gdb.rferl.org/07520000-0aff-0242-1513-08da3bd4d4c2_w1200.jpg',
    ps: {
      date: 'غویی ۲۹، ۱۴۰۱م کال ',
      description:
        ' طالبانو رسنیو ته امر وکړ چې ښځې باید په خپرونو کې له سترګو پرته خپل ټول مخ پټ کړي  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31862269.html',
        },
      ],
    },
    prs: {
      date: '۲۹ ثور ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان به رسانه ها دستور دادند که زنان در هنگام نشر برنامه ها باید صورت شانرا بجز از چشمان بپوشانند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/%D8%B8%D8%A7%D9%87%D8%B1-%D8%B4%D8%AF%D9%86-%D8%A8%D8%A7-%D9%85%D8%A7%D8%B3%DA%A9-%D8%B1%D9%88%DB%8C-%D8%B5%D9%81%D8%AD%DB%80-%D8%AA%D9%84%D9%88%DB%8C%D8%B2%DB%8C%D9%88%D9%86-%D9%85%D9%86%D8%B7%D9%82%DB%8C-%D9%86%DB%8C%D8%B3%D8%AA-/31859654.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 19
  {
    image:
      'https://gdb.rferl.org/23982029-2098-422c-9d98-52c73cfb903c_w1200.jpg',
    ps: {
      date: 'چنګاښ ۱۳, ۱۴۰۱م کال ',
      description: 'طالبانو، پرته له محرمه د ښځو پر سفر بندیز ولګاوه',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31927848.html',
        },
      ],
    },
    prs: {
      date: '۱۳ سرطان ۱۴۰۱ خورشیدی ',
      description:
        'طالبان سفر زنان را بدون محروم ممنوع اعلام کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32941513.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 20
  {
    image:
      'https://gdb.rferl.org/812ce76d-854a-4a22-ad64-51d99970803b_w1200.jpg',
    ps: {
      date: 'وږی ۰۳, ۱۴۰۲م کال ',
      description:
        ' طالبان وايي، ښځې او نجونې نور بند امیر ته د تګ اجازه نه لري  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32566840.html',
        },
      ],
    },
    prs: {
      date: '۳ سنبله ۱۴۰۲ خورشیدی ',
      description:
        ' طالبان رفتن دختران و زنان به بند امیر را منع قرار دادند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32941513.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 21
  {
    image:
      'https://gdb.rferl.org/2a1dffc0-2b0f-48b3-9169-cf0023fcb125_w1200.jpg',
    ps: {
      date: 'تله ۲۶, ۱۴۰۱م کال ',
      description:
        ' طالبانو د د کډوالو او بیرته راستنېدونکو چارو وزارت ښځينه کارکوونکې له دندو ځواب کړې  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32089329.html',
        },
      ],
    },
    prs: {
      date: '۲۶ میزان ۱۴۰۱ خورشیدی ',
      description:
        'طالبان کارمندان زن وزارت امور مهاجرین و عودت کنندگان را از وظایف شان اخراج کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32093317.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 22
  {
    image:
      'https://gdb.rferl.org/08ef0000-0a00-0242-1eae-08d9d048a6ec_w1200.jpeg',
    ps: {
      date: 'لړم ۱۵, ۱۴۰۱م کال ',
      description:
        ' طالبان ښځينه ناروغانو ته امر کړی چې یوازي دې ښځينه ډاکټرانو ته ورشي.',
      links: [
        {
          label: 'معلومات',
          url: 'https://da.azadiradio.com/a/32117864.html',
        },
      ],
    },
    prs: {
      date: '۱۵ عقرب ۱۴۰۱ خورشیدی ',
      description:
        'طالبان به مریضان زن دستور دادند که فقط به داکتران زن مراجعه کنند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32117864.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 23
  {
    image:
      'https://gdb.rferl.org/028e0000-0aff-0242-062e-08da1153a711_w1200.jpg',
    ps: {
      date: 'لړم ۱۷، ۱۴۰۱م کال ',
      description: 'طالبانو ښځې حمام او تفریحي پارکونو ته له تګه منع کړې',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32122316.html',
        },
      ],
    },
    prs: {
      date: '۱۷ عقرب ۱۴۰۱ خورشیدی ',
      description:
        'طالبان زنان را از رفتن به حمام و پارک های تفریحی منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32122467.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 24
  {
    image:
      'https://gdb.rferl.org/75396a1b-8492-41d7-8c58-2b962abe0cd3_w1200.jpg',
    ps: {
      date: 'لړم ۲۴, ۱۴۰۰ م کال  ',
      description:
        ' د ۱۲ ټولګیو زده ‌کوونکې به په کلنیو ازموینو کې ګډون نشي کولای  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/31562411.html',
        },
      ],
    },
    prs: {
      date: '۲۴عقرب ۱۴۰۰ خورشیدی ',
      description:
        'طالبان اعلام کردند که دختران که صنف دوازده مکتب بودند اجازه شرکت در امتحان سالانه را ندارند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/31562374.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 25
  {
    image:
      'https://gdb.rferl.org/bc5c0000-0aff-0242-6b3d-08d9cad9ff56_w1200.jpg',
    ps: {
      date: 'لیندۍ ۲۹, ۱۴۰۱م کال ',
      description: 'طالبانو د نجونو تحصيل وځنډاوه  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32186684.html',
        },
      ],
    },
    prs: {
      date: '۲۹ قوس ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان تحصیل دختران را به حالت تعلیق درآوردند. ',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32741638.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 26
  {
    image:
      'https://gdb.rferl.org/02860000-0aff-0242-b98e-08da0ce0a028_w1200.jpg',
    ps: {
      date: 'مرغومی ۱، ۱۴۰۱م کال ',
      description: 'طالبانو د نجونو پر خصوصي کورسونو بندیز ولګاوه',
      links: [
        {
          label: 'معلومات',
          url: 'https://da.azadiradio.com/a/32189313.html',
        },
      ],
    },
    prs: {
      date: '۱ جدی ۱۴۰۱ خورشیدی ',
      description:
        'طالبان دروس کورس های آموزشی برای دختران بالاتر از صنف ششم را منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32189313.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 27
  {
    image:
      'https://gdb.rferl.org/049b0000-0aff-0242-80f8-08da12096f51_w1200.png',
    ps: {
      date: 'مرغومی ۰۲, ۱۴۰۱م کال ',
      description: ' طالبانو د نجونو لیلیې بندول پیل کړل  ',
      links: [
        {
          label: 'نور معلومات',
          url: 'https://da.azadiradio.com/a/32190705.html',
        },
      ],
    },
    prs: {
      date: ' ۲ جدی ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان لیله های دخترانه را مسدود کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32190705.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 28
  {
    image: '',
    ps: {
      date: 'مرغومی ۰۳, ۱۴۰۱م کال  ',
      description: 'طالبانو په غیر دولتي ادارو کې د ښځو پر کار بندیز ولګاوه',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32193527.html',
        },
      ],
    },
    prs: {
      date: ' ۳ جدی ۱۴۰۱ خورشیدی ',
      description:
        'طالبان کار زنان در ادارات غیردولتی خارجی و داخلی را منع اعلام کردند.',
      links: [
        {
          label: ' معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32192235.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 29
  {
    image:
      'https://gdb.rferl.org/c045a487-aea9-4810-afa3-90581f3f1131_w1200.jpg',
    ps: {
      date: 'مرغومی ۴، ۱۴۰۱م کال ',
      description:
        'طالبانو د کابل په جوماتونو کې د بالغو نجونو پر دیني زده کړو بندیز ولګاوه  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32192851.html',
        },
      ],
    },
    prs: {
      date: '۴ جدی ۱۴۰۱ خورشیدی ',
      description:
        'طالبان آموزش دینی دختران بالغ در مساجد کابل را منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32192845.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 30
  {
    image: '',
    ps: {
      date: 'مرغومی ۱۳, ۱۴۰۱م کال ',
      description:
        'طالبانو په کنړ او ننګرهار کې د معلولو نجونو پر زده کړو بندیز ولګاوه  ',
      links: [
        {
          label: 'نور معلومات',
          url: 'https://pa.azadiradio.com/a/32207289.html',
        },
      ],
    },
    prs: {
      date: '۱۳ جدی ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان محدودیت های آموزشی را بر دختران معلول وضع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://pa.azadiradio.com/a/32207289.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 31
  {
    image:
      'https://gdb.rferl.org/9d87ec8a-92cf-4b17-a9b0-a95ecc0e4416_w1200.jpg',
    ps: {
      date: 'مرغومی ۱۹, ۱۴۰۱م کال ',
      description:
        ' طالبانو یوازي تر شپږم ټولګي پوري د نجونو د ښوونځيو د پرانیستلو امر وکړ.  ',
      links: [
        {
          label: 'نور معلومات',
          url: 'https://pa.azadiradio.com/a/32215957.html',
        },
      ],
    },
    prs: {
      date: '۱۹ جدی ۱۴۰۱ خورشیدی ',
      description:
        'طالبان دستور دادند که تنها مکاتب دخترانه بالاتر از صنف ششم در افغانستان بازگشایی شوند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://pa.azadiradio.com/a/32912660.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 32
  {
    image:
      'https://gdb.rferl.org/0b83ed72-980a-4e80-b3bd-46470953ffa8_w1200.jpg',
    ps: {
      date: 'سلواغه ۸، ۱۴۰۱م کال ',
      description:
        ' طالبانو د خصوصي پوهنتونونو لپاره د کانکور په ازموینه کې د نجونو پر ګډون بندیز ولګاوه  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32243834.html',
        },
      ],
    },
    prs: {
      date: '8 دلو ۱۴۰۱ خورشیدی ',
      description:
        ' طالبان دختران را از شرکت در امتحانات کانکور پوهنتون های خصوصی منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32973680.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 33
  {
    image:
      'https://gdb.rferl.org/08550000-0a00-0242-7dda-08daf9543937_w1200.jpg',
    ps: {
      date: 'وری ۱۱, ۱۴۰۲م کال  ',
      description:
        ' د طالبانو مشر د نویو مقرراتو له مخې د پخوانیو حل شویو قضیو د بیا ارزونې امر وکړ چې له کبله یې طلاقې شوې ښځې پخواني مېړونو ته د ستندېدو له خطر سره مخامخ شوې   ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32342566.html',
        },
      ],
    },
    prs: {
      date: '۱۱ حمل ۱۴۰۲ خورشیدی ',
      description:
        ' رهبر طالبان دستور ارزیابی مجدد دوسیه های حل شده در نظام قبلی را تحت مقررات جدید داد که زنان طلاق شده را در خطر بازگشت به همسران سابق شان قرار می دهد.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32342548.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 34
  {
    image:
      'https://gdb.rferl.org/9163d3b2-f199-467d-8938-5e6df2445a95_w1200.jpg',
    ps: {
      date: 'وری ۱۵, ۱۴۰۲م کال  ',
      description: 'طالبانو په ملګرو ملتونو کې د ښځو پر کار بندیز وګاوه',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32350305.html',
        },
      ],
    },
    prs: {
      date: '۱۵ حمل ۱۴۰۲ خورشیدی ',
      description:
        ' طالبان زنان افغان را از کار در ادارات سازمان ملل متحد در افغانستان منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32351021.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 35
  {
    image:
      'https://gdb.rferl.org/888cfb92-2679-4f2c-9f44-aa450c5356f9_w1200.jpg',
    ps: {
      date: 'وری ۲۷, ۱۴۰۲م کال  ',
      description:
        'طالبانو په کندهار ولایت کې د سیمه ییزو ټولګیو او ټولو ښوونیزو موسسو د ځنډولو امر وکړ  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32367216.html',
        },
      ],
    },
    prs: {
      date: '۲۷ حمل ۱۴۰۲ خورشیدی ',
      description:
        'طالبان دستور تعلیق کورس های محلی و موسسات آموزشی را در ولایت قندهار صادر کرد. ',
      links: [
        {
          label: 'معلومات بیشتر - پشتو',
          url: 'https://pa.azadiradio.com/a/32367216.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 36
  {
    image:
      'https://gdb.rferl.org/b702ebe4-23d8-4db7-8f56-c7161cb1eda2_w1200.jpg',
    ps: {
      date: 'چنګاښ ۱۳, ۱۴۰۲م کال  ',
      description:
        'طالبانو په افغانستان کې د ښځو د سینګارتونونو د بندېدو امر وکړ.  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32488615.html',
        },
      ],
    },
    prs: {
      date: '۱۳ سرطان ۱۴۰۲ خورشیدی ',
      description:
        'طالبان دستور بسته شدن آرایشگاه های زنانه را در افغانستان صادر کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32488674.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 37
  {
    image:
      'https://gdb.rferl.org/9a65677b-00f6-4e18-8432-eb31b8532be0_w1200.jpg',
    ps: {
      date: 'چنګاښ ۲۲، ۱۴۰۲م کال ',
      description:
        ' طالبانو د وړوکتونونو سلګونه ښځینه ښوونکې او کارکوونکې له دندو ګوښه کړې  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32502291.html',
        },
      ],
    },
    prs: {
      date: '۲۲ سرطان ۱۴۰۲ خورشیدی ',
      description:
        'طالبان صدها معلم زن و کارگر کودکستان ها را از وظایف شان اخراج کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32502274.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 38
  {
    image:
      'https://gdb.rferl.org/5338b1cf-0a4a-4578-9042-2ada53c9ee32_w1200.jpg',
    ps: {
      date: 'چنګاښ ۲۷, ۱۴۰۲م کال  ',
      description:
        'طالبان وايي چې د نجونو د زده کړو موضوع تر امر ثاني معطل وي، کانکور به یې هم معطل وي.   ',
      links: [
        {
          label: 'نور معلومات',
          url: 'https://pa.azadiradio.com/a/32508624.html',
        },
      ],
    },
    prs: {
      date: '۲۷ سرطان ۱۴۰۲ خورشیدی ',
      description:
        'طالبان گفتند که موضوع تحصیل دختران و زنان تا امر ثانی به حالت تعلیق باقی می ماند همچنان محدودیت زنان و دختران برای شرکت در کانکور هنوز هم پابرجاست.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32508800.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 39

  {
    image:
      'https://gdb.rferl.org/20665257-bd94-45c6-93b8-5e93195fcd39_w1200.jpg',
    ps: {
      date: 'چنګاښ ۲۷، ۱۴۰۲م کال  ',
      description:
        'طالبانو لویه څارنوالي لغوه او د ښځو په ګډون یې شا او خوا ۴۰۰۰ خدماتي پرسونل، ملکي او نظامي څارنوالان له دندو ګوښه او امتيازات يې قطع کړل   ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32510263.html',
        },
      ],
    },
    prs: {
      date: 'سرطان ۱۴۰۲ خورشیدی',
      description:
        'طالبان لوی سارنوالی را لغو کردند و 4000 تن را به شمول زنان از این اداره برکنار کردند.',
      links: [
        {
          label: ' معلومات بیشتر در لینک زیر',
          url: 'https://da.azadiradio.com/a/32510310.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 40
  {
    image:
      'https://gdb.rferl.org/01000000-0aff-0242-d57f-08db4bda07dc_w1200.jpg',
    ps: {
      date: 'زمری ۲۲، ۱۴۰۲م کال ',
      description:
        'طالبانو په رسنیو او تجارتي اعلانونو کې د ښځ پر ږغ بندیز ولګاوه ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32547185.html',
        },
      ],
    },
    prs: {
      date: '۲۲ اسد ۱۴۰۲ خورشیدی ',
      description:
        'طالبان صدای زنان را در رسانه ها و تبلیغات تجاری در ولایت هلمند ممنوع کردند.',
      links: [
        {
          label: ' معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32547600.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 41
  {
    image:
      'https://gdb.rferl.org/01000000-0a00-0242-feb0-08db5467a9cb_w1200.jpg',
    ps: {
      date: 'تله ۱۲، ۱۴۰۲م کال  ',
      description:
        'طالبانو د یوې کړنلارې تر جوړېدو د ښځینه سوداګرانو نندارتونونه وځنډول ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32622963.html',
        },
      ],
    },
    prs: {
      date: '۱۲ میزان ۱۴۰۲ خورشیدی ',
      description:
        ' طالبان نمایشگاه های تاجران زن را به حالت تعلیق درآوردند.  ',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://pa.azadiradio.com/a/32622963.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 42
  {
    image:
      'https://gdb.rferl.org/94a9c7ee-92b7-4f0b-ad85-ec7f7b29353e_w1200.jpg',
    ps: {
      date: 'وری ۰۵, ۱۴۰۳م کال ',
      description:
        ' طالبان به  پر ښځو په عام محضر کې د سنګسار او درو وهلو سزا پلې کوي  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32875316.html',
        },
      ],
    },
    prs: {
      date: '۵ حمل ۱۴۰۳ خورشیدی ',
      description:
        ' طالبان زنان را در محضر عام مجازات می کنند.',
      links: [
        {
          label: ' معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32875395.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 43
  {
    image:
      'https://gdb.rferl.org/c40260a3-1ddf-4a50-980f-216cbd7af212_w1200.png',
    ps: {
      date: 'وری ۵، ۱۴۰۳م کال ',
      description:
        'طالبانو په ننګرهار کې د خبریالۍ په روزنیز پروګرام کې له ګډونه منع کړې',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32875281.html',
        },
      ],
    },
    prs: {
      date: '۵ حمل ۱۴۰۳ خورشیدی ',
      description:
        'طالبان خبرنگاران زن را از شرکت در یک برنامه آموزشی در ننگرهار منع کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://pa.azadiradio.com/a/32875281.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 44
  {
    image:
      'https://gdb.rferl.org/01000000-c0a8-0242-5413-08db2154a9a2_w1200.jpg',
    ps: {
      date: 'غبرګولی ۱۵, ۱۴۰۳م کال  ',
      description:
        ' طالبانو د دولتي ادارو ټولو کارکوونکو معاشونه پنځه زره ته ټيټ کړل  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32988221.html',
        },
      ],
    },
    prs: {
      date: '۱۵ جوزا ۱۴۰۳  خورشیدی ',
      description:
        ' طالبان معاش همه کارمندان زن ادارات دولتی را به 5000 افغانی کاهش دادند.',
      links: [
        {
          label: ' معلومات بیشتر',
          url: 'https://da.azadiradio.com/a/32988178.html',
        },
      ],
    },
    en: null,
  },

  //NUMBER 45
  {
    image:
      'https://gdb.rferl.org/08550000-0a00-0242-b8a2-08db078abb7c_w1200.jpeg',
    ps: {
      date: 'وری ۳۱, ۱۴۰۳م کال ',
      description:
        ' طالبانو د کابل په ښوونیزو مرکزونو کې تر شپږم ټولګي پورته د نجونو پر جذب او زده‌ کړو بندیز ولګاوه  ',
      links: [
        {
          label: 'معلومات',
          url: 'https://pa.azadiradio.com/a/32912660.html',
        },
      ],
    },
    prs: {
      date: '۳۱ حمل ۱۴۰۳ خورشیدی ',
      description:
        'طالبان ثبت نام دختران بالاتر از صنف ششم را در مراکز آموزشی شهر کابل ممنوع اعلام کردند.',
      links: [
        {
          label: 'معلومات بیشتر',
          url: 'https://pa.azadiradio.com/a/32912660.html',
        },
      ],
    },
    en: null,
  },
    //NUMBER 46
    {
      image:
        'https://gdb.rferl.org/01000000-0aff-0242-66d4-08dcbc4596b3_w1200.jpg',
      ps: {
        date: 'زمری ۳۱، ۱۴۰۳م کال',
        description:
          'طالبانو د ښځې لوړ ږغ عورت وباله',
        links: [
          {
            label: 'نور معلومات',
            url: 'https://pa.azadiradio.com/a/33088657.html',
          },
        ],
      },
      prs: {
        date: '۳۱ اسد ۱۴۰۳ خورشیدی',
        description:
          'طالبان صدای بلند زنان را عورت خواندند',
        links: [
          {
            label: 'معلومات بیشتر',
            url: 'https://da.azadiradio.com/a/33088796.html',
          },
        ],
      },
      en: null,
    },
    //NUMBER 47
    {
      image:
        'https://gdb.rferl.org/034d0000-0aff-0242-72ee-08dae374d087_w1200.jpg',
      ps: {
        date: 'لېندۍ ۱۲، ۱۴۰۳م کال',
        description:
          'طالبانو په طبي انستیتیوتونو کې د نجونو پر زده‌کړو بندیز ولګاوه',
        links: [
          {
            label: 'نور معلومات',
            url: 'https://pa.azadiradio.com/a/33224058.html',
          },
        ],
      },
      prs: {
        date: '۲۱ قوس ۱۴۰۳ خورشیدی',
        description:
          'طالبان تحصیل دختران در انستیتوت های صحی را ممنوع کردند',
        links: [
          {
            label: 'معلومات بیشتر',
            url: 'https://da.azadiradio.com/a/33224152.html',
          },
        ],
      },
      en: null,
    },


    //NUMBER 48
    {
      image:
        'https://gdb.rferl.org/0c3fe342-c188-4893-afdf-8fe0e675e671_w1200.jpg',
      ps: {
        date: 'لیندۍ ۰۸, ۱۴۰۳',
        description:
          'د طالبانو حکومت په هرات کې د ښځو ټولې کافې وتړلې',
        links: [
          {
            label: 'نور معلومات',
            url: 'https://pa.azadiradio.com/a/33219162.html',
          },
        ],
      },
      prs: {
        date: '۸ قوس، ۱۴۰۳',
        description:
          'حکومت طالبان تمام کافه های زنان در هرات را بستند',
        links: [
          {
            label: 'معلومات بیشتر',
            url: 'https://da.azadiradio.com/a/33219200.html',
          },
        ],
      },
      en: null,
    },


    //NUMBER 49
    {
      image:
        'https://gdb.rferl.org/529efb6d-c92f-4f1d-ad4c-667f6fd9f674_w1200.jpg',
      ps: {
        date: ' لیندۍ ۲۶، ۱۴۰۳',
        description:
          'طالبانو اعلان وکړ چې د طبي پوهنځیو په اګزیټ ازموینو کې به یوازي نارینه ګډون کوي',
        links: [
          {
            label: 'نور معلومات',
            url: 'https://pa.azadiradio.com/a/33242918.html',
          },
        ],
      },
      prs: {
        date: '۲۶ قوس، ۱۴۰۳',
        description:
          'طالبان اعلام کردند که تنها مردان در امتحانات خروجی پوهنزی طب شرکت کرده می توانند',
        links: [
          {
            label: 'معلومات بیشتر',
            url: 'https://da.azadiradio.com/a/33242999.html',
          },
        ],
      },
      en: null,
    },
]
